import { Column, CellProps } from "react-table";
import { TInspectionTaskLink, TInspectionTask } from "../../types/types";
import { FaRegEdit, FaTrashAlt } from "react-icons/fa";


const makeColumn = <T extends object>(header: string, accessor: keyof T): Column<T> => ({
  Header: header,
  accessor,
});

export type InspectionTaskActionHandlers = {
  onEdit: (task: TInspectionTask) => void;
  onRemove: (task: TInspectionTask) => void;
};

export type InspectionTaskLinkActionHandlers = {
  onEdit: (link: TInspectionTaskLink) => void;
  onRemove: (link: TInspectionTaskLink) => void;
};

// Inspection Task Columns (list of tasks)
export const getInspectionTaskColumns = (handlers: InspectionTaskActionHandlers): Column<TInspectionTask>[] => [
  makeColumn<TInspectionTask>("Task Header", "taskHeader"),
  makeColumn<TInspectionTask>("Task Description", "taskDescription"),
  makeColumn<TInspectionTask>("list Order", "listOrder"),
  {
    Header: "Actions",
    id: "actions",
    Cell: ({ row }: CellProps<TInspectionTask>) => (
      <div className="flex items-center gap-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            handlers.onEdit(row.original);
          }}
          className="text-blue-500 hover:text-blue-700 p-1"
          title="Edit"
        >
          <FaRegEdit size={18} />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handlers.onRemove(row.original);
          }}
          className="text-red-500 hover:text-red-700 p-1"
          title="Remove"
        >
          <FaTrashAlt size={18} />
        </button>
      </div>
    ),
  },
];

// Inspection Task Links Columns with Actions
export const getInspectionTaskLinksColumns = (handlers: InspectionTaskLinkActionHandlers): Column<TInspectionTaskLink>[] => [
  makeColumn<TInspectionTaskLink>("Link Text", "linkText"),
  makeColumn<TInspectionTaskLink>("Link Category", "linkCategory"),
  {
    Header: "Actions",
    id: "actions",
    Cell: ({ row }: CellProps<TInspectionTaskLink>) => (
      <div className="flex items-center gap-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            handlers.onEdit(row.original);
          }}
          className="text-blue-500 hover:text-blue-700 p-1"
          title="Edit"
        >
          <FaRegEdit size={18} />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handlers.onRemove(row.original);
          }}
          className="text-red-500 hover:text-red-700 p-1"
          title="Remove"
        >
          <FaTrashAlt size={18} />
        </button>
      </div>
    ),
  },
];


